import serviceBase from "./serviceBase";
import { EndPoint } from "../appConfig";

var CheckoutService = Object.create(
  new serviceBase(EndPoint.Checkout)
);
CheckoutService.getCheckoutsById = function (meetingId) {
  return this.get({
    meeting_id: meetingId
  });
};
CheckoutService.doCheckout = function (
  meetingId,
  roomId,
  roomTag,
  success
) {
  var _this = this;
  _this.post({
    event: {
      ical_uid: meetingId
    },
    room_id: roomId,
    room_tag: roomTag
  }).then(success);
};
export default CheckoutService;